import { api } from 'app/api'
import { useCallback, useState } from 'react'
import { DietFoodTypeId } from 'app/dataTypes/org/dietFoodTypes'
import { POST_SCHOOL_DIET_FOOD_TYPES, convertParamsDelete, convertParamsUpdate } from 'app/common/api/requests/food/schools/diet_food_types/post'
import { OrgId } from 'app/dataTypes/org'

interface Options {
  orgId: OrgId
}
export const useSchoolDietFoodTypesMutate = ({ orgId }: Options) => {
  const [pending, setPending] = useState<boolean>(false)

  const remove = useCallback(async (removeId: DietFoodTypeId) => {
    setPending(true)

    const res = await api.request(POST_SCHOOL_DIET_FOOD_TYPES, {
      error: 'Не удалось удалить диетическое питание из списка для школы',
      params: {
        orgId,
        removeId
      },
      convertions: {
        convertParams: convertParamsDelete,
      },
    })
    if (res) {
      setPending(false)
      return true
    }
    setPending(false)
    return false
  }, [orgId])


  const submit = useCallback(async (setIds: Array<DietFoodTypeId>) => {
    setPending(true)
    const res = await api.request(POST_SCHOOL_DIET_FOOD_TYPES, {
      error: 'Не удалось обновить список видов диетического питания для школы',
      params: {
        orgId,
        setIds
      },
      convertions: {
        convertParams: convertParamsUpdate,
      },
    })
    if (res) {
      setPending(false)
      return true
    }
    setPending(false)
    return false
  }, [orgId])


  return {
    pending,
    submit,
    remove
  }
}
